import request from "@/utils/request";

export function searchAllDataListApi(page, size, title) {
  return request({
    url:
      "searchAllDataList?pageNum=" +
      page +
      "&pageSize=" +
      size +
      "&title=" +
      title,
    method: "GET",
  });
}
